// extracted by mini-css-extract-plugin
export default {"split-button":"components-hotel-settings-central-mapping-tables-table-mapping-module__split-button"};